import React from "react";
import withIconComponent from "../withIconComponent";

var Cross = function Cross() {
  return /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 5L5 19M19 19L5 5"
  }));
};

export default withIconComponent("UiCross", false)(Cross);